import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { categories, recentPosts } from "../../data/posts";

function Footer() {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="gy-4 text-center text-md-start">
          <Col md={4}>
            <h6>APK Downloads</h6>
            <p className="small footer-p text-center text-md-start" style={{ maxWidth: 320 }}>
              Your daily source for app reviews, game tricks, tech news and
              how-to guides. We share information and link to official sources
              we do not host copyrighted files.
            </p>
          </Col>

          <Col xs={6} md={3} className="text-center text-md-start">
            <h6>Categories</h6>
            {categories.slice(0, 6).map((c) => (
              <Link key={c.slug} to={`/category/${c.slug}`}>{c.name}</Link>
            ))}
          </Col>

          <Col xs={6} md={2}>
            <h6>Pages</h6>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact Us</Link>
            <Link to="/disclaimer">Disclaimer</Link>
            <Link to="/privacy">Privacy Policy</Link>
          </Col>

          <Col md={3}>
            <h6>Recent Posts</h6>
            {recentPosts.slice(0, 3).map((p) => (
              <Link key={p.id} to={`/post/${p.slug}`}>
                {p.title.length > 40 ? p.title.slice(0, 40) + "…" : p.title}
              </Link>
            ))}
          </Col>
        </Row>

        <div className="footer-bottom d-flex flex-column flex-md-row justify-content-between gap-2 text-center text-md-start">
          <span>© 2026 APK Downloads. All rights reserved.</span>
          <span>Android is a trademark of Google LLC. We are not affiliated with Google.</span>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
